import axios, { AxiosResponse } from 'axios';
import { authFetch } from '.';
import {
  IPersonSoftDeleteResponse,
  IPropertySoftDeleteResponse,
  ICompanySoftDeleteResponse,
  ISoftDeleteFilters,
} from '../models/soft-deletes';

const baseUrl = '/api/Admin/removed';

export const SoftDeleteAPI = {
  async getPeople(filters?: ISoftDeleteFilters): Promise<IPersonSoftDeleteResponse> {
    try {
      const response: AxiosResponse<IPersonSoftDeleteResponse> = await authFetch.get(
        `${baseUrl}/people`,
        filters
      );
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async restorePerson(personId: number): Promise<void> {
    try {
      await authFetch.post(`${baseUrl}/people/${personId}/restore`, {});
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async getProperties(filters?: ISoftDeleteFilters): Promise<IPropertySoftDeleteResponse> {
    try {
      const response: AxiosResponse<IPropertySoftDeleteResponse> = await authFetch.get(
        `${baseUrl}/properties`,
        filters
      );
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async restoreCompany(companyId: number): Promise<void> {
    try {
      await authFetch.post(`${baseUrl}/companies/${companyId}/restore`, {});
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
  async getCompanies(filters?: ISoftDeleteFilters): Promise<ICompanySoftDeleteResponse> {
    try {
      const response: AxiosResponse<ICompanySoftDeleteResponse> = await authFetch.get(
        `${baseUrl}/companies`,
        filters
      );
      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async restoreProperty(propertyId: number): Promise<void> {
    try {
      await authFetch.post(`${baseUrl}/properties/${propertyId}/restore`, {});
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
};
